<template>
<v-app>
<v-content>
  <v-container fluid ma-0 pa-0 v-resize="onResize">
    <v-img src="../../../static/img/background_small.jpg" :width="x" :height="y" class="bgimage">
      <nav class="navbar navbar-light" style="height: 10px;">
        <a class="navbar-brand" href="#">
          <img src="../../assets/img/logo.png" width="60" height="40" class="d-inline-block align-top" alt="">
          <div style="display: inline-block; padding-left: 5px; color: white;font-weight: 700;">
            <span> KENYA COFFEE </span>
          </div>
        </a>
        <div id="navbarNav" style="margin-right: 200px;">
          <ul class="nav justify-content-end">
            <li class="nav-item">
              <a class="nav-link links" href="/">Home</a>
            </li>
            <li class="nav-item">
              <a class="nav-link links" href="https://onlinebanking.co-opbank.co.ke/" target="_blank">Co-op Online</a>
            </li>
            <li class="nav-item">
              <a class="nav-link links" href="https://www.nairobicoffeeexchange.co.ke/" target="_blank">NCE</a>
            </li>
            <li class="nav-item">
              <a class="nav-link links" href="https://www.agricultureauthority.go.ke/" target="_blank">AFA</a>
            </li>
            <li class="nav-item">
              <a class="nav-link links" href="https://www.cma.or.ke/" target="_blank">CMA</a>
            </li>
            <li class="nav-item">
              <a class="nav-link links active" href="/contactus">Contact Us</a>
            </li>
          </ul>
        </div>
      </nav>
      <v-layout align-center row  fill-height wrap>
        <v-flex xs4 offset-xs5 class="loginfront">
          <h3 class="white--text loginhead"> Enter Password Reset otp to proceed </h3>
          <v-flex v-if="tokenInvalidMessage">
            <p class="loginresponse">{{tokenInvalidMessage}}</p>
          </v-flex>
          <v-form ref="form" v-model="valid" lazy-validation>

            <div class="wrap-input100" style="margin-bottom: 40px;">
              <input class="input100" type="text" name="email" v-model="user.confirmPassword" v-on:blur="blurOtp" :class="removeOtpLabel === true ? 'has-val' : ''">
              <span class="focus-input100"></span>
              <span class="label-input100"> Enter OTP</span>
            </div>
          </v-form>
          <div class="logindiv">
            <a mt-5 class="pageLink white--text" href="/login"> Back to login?  </a>
            <v-btn class="btn loginbtn primary--text"   @click="getPasswordResetTokenDetails" > Submit </v-btn>

          </div>
        </v-flex>
      </v-layout>
    </v-img>
  </v-container>
</v-content>
</v-app>
</template>

<!--<template>-->
<!--  <div>-->
<!--  <v-toolbar color="primary" fixed app dense>-->
<!--    <v-toolbar-title class="subheading"> COFFEE DSS </v-toolbar-title>-->
<!--    <v-spacer></v-spacer>-->
<!--  </v-toolbar>-->
<!--  <v-app>-->
<!--    <v-content>-->
<!--      <v-container>-->
<!--        <v-layout row justify-center wrap>-->
<!--          <v-flex xs8>-->
<!--              <v-card elevation-12>-->
<!--                <v-card-title primary-title>-->
<!--                  <h3 class="headline mb-2">Enter OTP</h3>-->
<!--                </v-card-title>-->
<!--                <v-card-text >-->
<!--                  <v-alert v-if="!tokenValid" :value="true" color="error"> {{ tokenInvalidMessage }} </v-alert>-->
<!--                 <v-form ref="form" v-model="valid" lazy-validation>-->
<!--                    &lt;!&ndash; <v-text-field-->
<!--                      name="email"-->
<!--                      label="Username"-->
<!--                      v-model="user.email"-->
<!--                      readonly-->
<!--                      required>-->
<!--                    </v-text-field>-->
<!--                    <v-text-field-->
<!--                      name="password"-->
<!--                      label="Password"-->
<!--                      v-model="user.password"-->
<!--                      :type="'password'"-->
<!--                      :rules="passwordRules"-->
<!--                      required>-->
<!--                    </v-text-field>-->
<!--                    <v-list v-if="passwordValidationError">-->
<!--                        <template v-for="(item, index) in passwordErrors">-->
<!--                          <v-list-item color="error" :key="index">-->
<!--                            <v-list-item-content>-->
<!--                              {{ item }}-->
<!--                            </v-list-item-content>-->
<!--                          </v-list-item>-->
<!--                        </template>-->
<!--                    </v-list> &ndash;&gt;-->
<!--                    <v-text-field-->
<!--                      color="primary"-->
<!--                      name="confirmPassword"-->
<!--                      label="Enter OTP"-->
<!--                      v-model="user.confirmPassword"-->
<!--                      :type="'text'"-->
<!--                      required>-->
<!--                    </v-text-field>-->
<!--                    </v-form>-->
<!--                  </v-card-text>-->
<!--                 <v-card-actions>-->
<!--                    <v-btn @click="getPasswordResetTokenDetails" color="primary">Submit</v-btn>-->
<!--                 </v-card-actions>-->
<!--              </v-card>-->
<!--          </v-flex>-->
<!--        </v-layout>-->
<!--      </v-container>-->
<!--    </v-content>-->
<!--  </v-app>-->
<!--  <v-footer color="primary" app inset>-->
<!--    <div class="white&#45;&#45;text">-->
<!--    <strong>Copyright &copy; {{year}}-->
<!--      Co-operative Bank</strong> All rights reserved.-->
<!--    </div>-->
<!--  </v-footer>-->
<!-- </div>-->
<!--</template>-->
<script>
import axios from 'axios'
import config from '../../config'
import store from '../../store'

export default {
  name: 'OTPView',
  data: function () {
    return {
      year: new Date().getFullYear(),
      section: 'OTPView',
      confirmToken: '',
      response: '',
      tokenValid: true,
      tokenInvalidMessage: '',
      user: {
        // email: '',
        // password: '',
        otp: ''
      },
      valid: false,
      passwordRules: [
        v => !!v || 'Password is required',
        v => (v && v.length > 7) || 'Password length should be atleast 8 characters'
      ],
      // confirmPasswordRules: [
      //   //  Put inplace logic to check compare sent otp vs entered otp
      //   v => !!v || 'OTP is required',
      //   v => (v && v === '1234') || 'Please enter the correct OTP'
      // ],
      passwordValidationError: false,
      passwordErrors: []
    }
  },
  mounted () {
    // var urlString = window.location.href
    // var url = new URL(urlString)
    // var t = url.searchParams.get('token')
    // this.resetToken = t
    // console.log(t)
    // this.getPasswordResetTokenDetails()
  },
  methods: {
    getPasswordResetTokenDetails () {
      // var url = config.serverURI + '/confirm/passwordreset?token=' + this.resetToken
      var url = config.serverURI + '/confirm/validateOTP'
      console.log(this.user.confirmPassword)
      axios
        .post(url, { otp: this.user.confirmPassword })
        .then(response => {
          var data = response.data

          if (data.error === true) {
            this.tokenValid = false
            this.tokenInvalidMessage = data.message
            console.log(this.tokenInvalidMessage)
            return
          } else {
            console.log('Data dot message', data.message)
            const userEmail = data.message
            // this.$router.push({ path: 'OTPConfrimView', params: { email: userEmail } })
            this.$router.push({ path: `/confirmpassword/${userEmail}` })
          }
          this.user.email = data.message
          console.log(data)
        })
        .catch(error => {
          this.$store.commit('TOGGLE_LOADING')
          console.log(error)

          this.tokenInvalidMessage = 'Server appears to be offline'
          this.toggleLoading()
        })
    },
    toggleLoading () {
      this.loading = this.loading === '' ? 'loading' : ''
    },
    resetResponse () {
      this.response = ''
    },
    blurOtp () {
      if (this.otp === '') {
        this.removeOtpLabel = false
      } else {
        this.removeOtpLabel = true
      }
    },
    resetPassword () {
      this.message = ''
      this.error = ''
      this.passwordErrors = []
      if (this.$refs.form.validate()) {
        var url = config.serverURI + '/confirm/validateOTP'
        var token = store.state.token
        axios.post(url, this.user, {
          headers: {
            Authorization: token,
            'Content-Type': 'application/json'
          }
        })
          .then(response => {
            console.log('API Response:', response)

            if (response.status !== 200) {
              this.error = response.statusText
              console.log('Error is ' + this.error)
              return
            }
            if (response.data.valid === false) {
              this.passwordErrors = response.data.passwordErrors
              console.log('Error is ' + this.passwordErrors)
              this.passwordValidationError = true
              return
            }
            if (response.data.error !== false) {
              this.tokenValid = false
              this.tokenInvalidMessage = response.data.message
              return
            } else {
              window.location = '/login?message=' + response.data.message
            }

            this.resetUserObject()
            this.$refs.form.reset()
            this.message = response.data.message
          })
          .catch(error => {
            // Request failed.
            console.log('error', error.response)
          })
      }
    }
  }
}

</script>
<style scoped>
.labelstyle >>> .v-text-field__slot label {
  color: white;
  font-weight: 300px !important;
  font-family: 'Open Sans', sans-serif;
}

.inputstyle >>> .v-text-field__slot input {
  color: white;
  font-family: 'Open Sans', sans-serif;
  font-size: 20px;
}

.loginresponse {
  color: red;
  font-weight: 600;
}

.loginbtn {
  font-weight: bold;
  text-transform: capitalize;
  border-radius: 5px 5px 5px 5px;
  float: right;
  background-color: #B2CCC4 !important;
  width: 100px;
  border-color: #FFF;
  color:;
}

.loginfront {
  background: #000000B2 0% 0% no-repeat padding-box;
  padding-left: 40px;
}
.logindiv {
  margin: 0;
  width: 80%;
  margin-bottom: 20px;
  height: 50px;
  text-align: justify;
}
.pageLink {
  font-size: 14px;
  padding-top:10px;
  font-style: "Brandon Grotesque";
}
.loginhead {
  font-size: 14px;
  font-weight: 700;
  font-style: "Brandon Grotesque";
  margin-top:30px;
  margin-bottom:20px;
}
.links {
  padding-left: 30px;
  padding-right: 30px;
  color: white;
  font-size: 14px;
  font-weight: 600;
  font-style:"Brandon Grotesque";
}
.active {
  width: 150px;
  background-color: #7BC243;
  text-align: center;
  border-radius: 5px 5px 5px 5px;
}
</style>
